import { ArrowRight } from "lucide-react";

export default function AnalysisHub({ analysisCards = [] }) {
  return (
    <div className="mt-8">
      <h2 className="text-xl font-semibold mb-5">
        Drill-down Analysis
      </h2>

      <div className="grid gap-6 lg:grid-cols-3">
        {analysisCards.map((card) => (
          <div
            key={card.title}
            className="group rounded-2xl border bg-white p-6 shadow-sm hover:shadow-lg transition"
          >
            {/* Icon */}
            <div
              className={`w-14 h-14 rounded-xl flex items-center justify-center ${card.color}`}
            >
              {card.icon}
            </div>

            {/* Title */}
            <h3 className="mt-5 text-lg font-semibold">
              {card.title}
            </h3>

            {/* Description */}
            <p className="mt-3 text-sm text-slate-500 leading-6 min-h-[70px]">
              {card.description}
            </p>

            {/* Analysis Stats */}
            {card.type === "payment-party" && (
              <div className="mt-4 flex items-center gap-6">
                <div>
                  <div className="text-xs text-slate-500">
                    Matched
                  </div>

                  <div className="text-xl font-semibold text-green-600">
                    {card.stats?.matched ?? 0}
                  </div>
                </div>

                <div className="h-8 w-px bg-slate-200" />

                <div>
                  <div className="text-xs text-slate-500">
                    Unmatched
                  </div>

                  <div className="text-xl font-semibold text-red-600">
                    {card.stats?.unmatched ?? 0}
                  </div>
                </div>
              </div>
            )}

            {card.type === "transaction-explorer" && (
              <div className="mt-4 flex items-center gap-6">
                <div>
                  <div className="text-xs text-slate-500">
                    Matched
                  </div>

                  <div className="text-xl font-semibold text-green-600">
                    {card.stats?.matched ?? 0}
                  </div>
                </div>

                <div className="h-8 w-px bg-slate-200" />

                <div>
                  <div className="text-xs text-slate-500">
                    Unmatched
                  </div>

                  <div className="text-xl font-semibold text-red-600">
                    {card.stats?.unmatched ?? 0}
                  </div>
                </div>
              </div>
            )}

            {card.type === "column-mismatch" && (
              <div className="mt-4">
                <div className="text-xs text-slate-500">
                  Most Mismatched Column
                </div>

                <div
                  className="mt-1 text-base font-semibold text-orange-600 truncate"
                  title={card.stats?.columnName || "N/A"}
                >
                  {card.stats?.columnName || "N/A"}
                </div>

                <div className="mt-1 text-xs text-slate-500">
                  {card.stats?.mismatchCount ?? 0} mismatches
                </div>
              </div>
            )}

            {/* Button */}
            <button
              onClick={card.onClick}
              className="mt-6 flex items-center gap-2 text-primary font-medium group-hover:gap-3 transition-all"
            >
              {card.button}
              <ArrowRight size={18} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}